var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.253 13.427H9.7a.812.812 0 0 0-.805.816c0 .45.36.816.805.816h4.553a.811.811 0 0 0 .806-.816.812.812 0 0 0-.806-.816z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.796 5.224-7.006 9.06a1.678 1.678 0 0 1-1.303.651l-2.792.034a.319.319 0 0 1-.313-.248l-.635-2.752a1.7 1.7 0 0 1 .322-1.431l4.967-6.429a.25.25 0 0 1 .338-.043l2.09 1.663a.675.675 0 0 0 .516.146.753.753 0 0 0 .652-.831.837.837 0 0 0-.262-.506L7.339 2.909a.302.302 0 0 1-.05-.419l.786-1.02c.728-.935 1.997-1.02 3.02-.207l1.177.935c.482.377.804.874.914 1.397.127.575-.009 1.14-.39 1.629z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.3b0926741d4e1d8fc7c1a4af794f6e4f.svg";
export { ForwardRef as ReactComponent };